import { render, staticRenderFns } from "./DeleteCustomerDialog.vue?vue&type=template&id=7c2ebd12"
import script from "./DeleteCustomerDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports